import { render, staticRenderFns } from "./CircletalkIcon.vue?vue&type=template&id=f05ffb72&"
import script from "./CircletalkIcon.vue?vue&type=script&lang=js&"
export * from "./CircletalkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports